var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyDocuments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M45.6794 14.8993C46.823 10.6316 51.2097 8.09889 55.4774 9.24243L136.615 30.9832C140.883 32.1268 143.416 36.5135 142.272 40.7812L114.32 145.101C113.176 149.369 108.789 151.902 104.522 150.758L23.3838 129.017C19.1161 127.874 16.5835 123.487 17.727 119.219L45.6794 14.8993Z",
    fill: "#F1F2F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 26C30 21.5817 33.5817 18 38 18H122C126.418 18 130 21.5817 130 26V118L106 142H38C33.5817 142 30 138.418 30 134V26Z",
    fill: "#E7E9EC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106 118H130L106 142V118Z",
    fill: "#CFD3D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9774 95.2992L95.2773 89.6571C95.5146 89.2313 95.5146 88.7203 95.2773 88.3158L94.2421 86.5273L88.7207 95.9805H90.8128C91.2873 95.9805 91.7402 95.725 91.9774 95.2992Z",
    fill: "#9FA7B3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0243 95.2974L97.8223 93.9561C98.0596 93.5303 98.0596 93.0193 97.8223 92.6148L96.7871 90.8477L93.7676 96H95.8597C96.3126 95.9787 96.7655 95.7233 97.0243 95.2974Z",
    fill: "#9FA7B3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.215 95.9805L64.6937 86.5273L63.6584 88.3158C63.4212 88.7416 63.4212 89.2526 63.6584 89.6571L66.9367 95.2992C67.174 95.725 67.6269 95.9805 68.1229 95.9805H70.215Z",
    fill: "#9FA7B3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2132 90.7617L61.1779 92.5289C60.9407 92.9547 60.9407 93.4657 61.1779 93.8702L61.9975 95.2967C62.2348 95.7225 62.6877 95.978 63.1837 95.978H65.2758L62.2132 90.7617Z",
    fill: "#9FA7B3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3118 95.9783H85.7647C86.2607 95.9783 86.7137 95.7228 86.9509 95.297L92.7742 85.3329C93.0115 84.9071 93.0115 84.3961 92.7742 83.9916L91.739 82.2031L84.4922 94.5731L85.3118 95.9783Z",
    fill: "#9FA7B3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2404 95.9793L68.0152 83.6094H66.376L66.1604 84.0139C65.9231 84.4397 65.9231 84.9507 66.1604 85.3552L71.9837 95.298C72.2209 95.7239 72.6739 95.9793 73.1699 95.9793H75.2404Z",
    fill: "#9FA7B3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4137 92.7403L90.2507 81.0516C90.488 80.6258 90.488 80.1148 90.2507 79.7103L89.2155 77.9219L81.9902 90.2918L83.4137 92.7403Z",
    fill: "#9FA7B3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1719 83.6094L77.0089 95.298C77.2461 95.7239 77.6991 95.9793 78.1951 95.9793H80.2872L73.0404 83.6094H70.1719Z",
    fill: "#9FA7B3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0874 83.6094H75.1973L82.0343 95.298C82.2715 95.7239 82.7245 95.9793 83.2205 95.9793H85.3126L78.0874 83.6094Z",
    fill: "#9FA7B3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7667 68.2578H76.1669C75.6708 68.2578 75.2395 68.5133 74.9807 68.9391L73.9238 70.7063H84.9881L83.9529 68.9178C83.6941 68.5133 83.2411 68.2578 82.7667 68.2578Z",
    fill: "#9FA7B3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2864 64H78.6473C78.1512 64 77.7199 64.2555 77.461 64.6813L76.4258 66.4697H82.5079L81.4727 64.6813C81.2354 64.2555 80.7825 64 80.2864 64Z",
    fill: "#9FA7B3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M86.692 73.6231L86.4548 73.2399C86.2175 72.8141 85.7646 72.5586 85.2685 72.5586H73.6219C73.1258 72.5586 72.6945 72.8141 72.4356 73.2399L71.4004 75.0283H85.8724L86.692 73.6231Z",
    fill: "#9FA7B3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7959 76.8594H71.1219C70.6258 76.8594 70.1945 77.1149 69.9356 77.5407L68.9004 79.3291H83.3724L84.7959 76.8594Z",
    fill: "#9FA7B3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4318 81.8219L66.375 83.6104H80.847L82.2921 81.1406H68.6181C68.122 81.1619 67.6691 81.4174 67.4318 81.8219Z",
    fill: "#9FA7B3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M86.692 73.625L79.4668 85.995L80.9118 88.4647L87.7489 76.776C87.9861 76.3502 87.9861 75.8392 87.7489 75.4347L86.692 73.625Z",
    fill: "#9FA7B3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyDocuments);
export default __webpack_public_path__ + "static/media/empty-documents.3e2afeeb98f18fc3df7afa19ee1c17cd.svg";
export { ForwardRef as ReactComponent };